var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-end" }, [
    _c("div", { staticClass: "col-6 col-md-4 text-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-danger",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.logout.apply(null, arguments)
            }
          }
        },
        [_c("i", { staticClass: "fas fa-sign-out-alt" }), _vm._v(" ออกจากระบบ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d52f0ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d52f0ee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/Header.vue
// module id = 1899
// module chunks = 0